import React from 'react';
import { useLocation } from 'react-router-dom';
import NavigationDock from './NavigationDock';

/**
 * AppLayout - Provides a rigid app shell with:
 * - Fixed viewport (no page scrolling)
 * - Fixed navigation dock at bottom
 * - Scrollable content area in between
 * 
 * Pages that handle their own layout (Studio, Vault) can opt out.
 */
export default function AppLayout({ children, hideNav = false, fullScreen = false }) {
  const location = useLocation();
  
  // Pages that manage their own navigation and layout
  const selfManagedPages = ['/studio', '/vault'];
  const isSelfManaged = selfManagedPages.includes(location.pathname);
  
  // If page is self-managed or fullScreen requested, just render children
  if (isSelfManaged || fullScreen) {
    return (
      <div className="app-layout-full">
        {children}
      </div>
    );
  }

  return (
    <div className="app-layout">
      {/* Scrollable content area */}
      <main className="app-content">
        {children}
      </main>
      
      {/* Fixed navigation dock */}
      {!hideNav && <NavigationDock />}
    </div>
  );
}
